import { words } from 'globalState';
import { devLog, syncHttpRequest2, localTime } from 'utils';

// 「デュエル履歴検索」ボタン押下 HANDLE CLICK GET DUEL HISTORY ALL
async function handleClickGetDuelHistoryAll(state, dispatch, pagingIndex, directAccessParameters) {
  let start;
  let end;
  let request = {};
  let messages = {};

  // state固定
  const stateFixed = {
    action: state.getDuelHistory.action,
    addressMain: state.active.addressMain,
    sessionId: state.session[state.active.addressMain]?.sessionId,
    lastEvaluatedKey: pagingIndex >= 1 ? state.getDuelHistory.lastEvaluatedKey[state.getDuelHistory.action][pagingIndex - 1] : null,
    // lastEvaluatedSortKey: pagingIndex >= 1 ? state.getDuelHistory.lastEvaluatedKey[state.getDuelHistory.action][pagingIndex - 1]?.duelNo : null,
    lastEvaluatedKey2: pagingIndex >= 1 ? state.getDuelHistory.lastEvaluatedKey2[state.getDuelHistory.action]?.[pagingIndex - 1] : null,
    // lastEvaluatedSortKey2: pagingIndex >= 1 ? state.getDuelHistory.lastEvaluatedKey2[state.getDuelHistory.action]?.[pagingIndex - 1]?.duelNo : null,
    epochFrom: state.searchDateRange.from.epoch,
    yearFrom: state.searchDateRange.from.year,
    monthFrom: state.searchDateRange.from.month,
    dayFrom: state.searchDateRange.from.day,
    epochTo: state.searchDateRange.to.epoch,
    yearTo: state.searchDateRange.to.year,
    monthTo: state.searchDateRange.to.month,
    dayTo: state.searchDateRange.to.day,
    duelistAddress: state.getDuelHistory.duelistAddress,
    roomId: state.getDuelHistory.roomId,
    duelNo: state.getDuelHistory.duelNo,
  };

  if (directAccessParameters?.action === 'duelHistorySingle') {
    stateFixed.action = 'duelHistorySingle';
    stateFixed.roomId = directAccessParameters.roomId;
    stateFixed.duelNo = directAccessParameters.duelNo;
  }
  else if (directAccessParameters?.action === 'duelHistoryAll') {
    stateFixed.action = 'duelHistoryAll';
  }

  devLog('from', `${stateFixed.yearFrom}/${stateFixed.monthFrom}/${stateFixed.dayFrom}`);
  devLog('from epoch', localTime(stateFixed.epochFrom));
  devLog('to', `${stateFixed.yearTo}/${stateFixed.monthTo}/${stateFixed.dayTo}`);
  devLog('to epoch', localTime(stateFixed.epochTo));

  // 入力値チェック
  // -- 開始年月日
  if ((stateFixed.yearFrom === undefined || stateFixed.yearFrom === null || stateFixed.yearFrom === '') &&
      (stateFixed.monthFrom === undefined || stateFixed.monthFrom === null || stateFixed.monthFrom === '') &&
      (stateFixed.dayFrom === undefined || stateFixed.dayFrom === null || stateFixed.dayFrom === '')         ) {
    start = undefined;
  }
  else {
    if (stateFixed.yearFrom < 1970 || stateFixed.yearFrom > 9999) {
      devLog('year is out of range.');
      dispatch({ type: 'setNotification', key: 'notification', value: words.yearIsOutOfRange[state.language] });
      return { status: 'rejected' };
    }

    if (stateFixed.monthFrom < 1 || stateFixed.monthFrom > 12 ||
        stateFixed.dayFrom < 1 || stateFixed.dayFrom > 31) {
      devLog('month or day is out of range.');
      dispatch({ type: 'setNotification', key: 'notification', value: words.monthOrDayIsOutOfRange[state.language] });
      return { status: 'rejected' };
    }

    start = stateFixed.epochFrom;
  }

  // -- 終了年月日
  if ((stateFixed.yearTo === undefined || stateFixed.yearTo === null || stateFixed.yearTo === '') &&
      (stateFixed.monthTo === undefined || stateFixed.monthTo === null || stateFixed.monthTo === '') &&
      (stateFixed.dayTo === undefined || stateFixed.dayTo === null || stateFixed.dayTo === '')         ) {
    end = undefined;
  }
  else {
    if (stateFixed.yearTo < 1970 || stateFixed.yearTo > 9999) {
      devLog('year is out of range.');
      dispatch({ type: 'setNotification', key: 'notification', value: words.yearIsOutOfRange[state.language] });
      return { status: 'rejected' };
    }

    if (stateFixed.monthTo < 1 || stateFixed.monthTo > 12 ||
        stateFixed.dayTo < 1 || stateFixed.dayTo > 31       ) {
      devLog('month or day is out of range.');
      dispatch({ type: 'setNotification', key: 'notification', value: words.monthOrDayIsOutOfRange[state.language] });
      return { status: 'rejected' };
    }

    end = stateFixed.epochTo;
  }

  // -- デュエリストアドレス ← このチェックは実は不要。
  if (stateFixed.action === 'duelHistoryAddress') {
    if (stateFixed.duelistAddress === undefined || stateFixed.duelistAddress === null || stateFixed.duelistAddress === '') {
      dispatch({ type: 'setNotification', key: 'notification', value: words.duelistAddressMustBeFilled[state.language] });
      return { status: 'rejected' };
    }
  }


  request.body = JSON.stringify({
    body: {
      action: stateFixed.action,
      duelistAddress: stateFixed.duelistAddress,
      roomId: stateFixed.roomId,
      duelNo: stateFixed.duelNo,
      start: start,
      end: end,
      addressMain: stateFixed.addressMain,
      sessionId: stateFixed.sessionId,
      lastEvaluatedKey: stateFixed.lastEvaluatedKey,
      // lastEvaluatedSortKey: stateFixed.lastEvaluatedSortKey,
      lastEvaluatedKey2: stateFixed.lastEvaluatedKey2,
      // lastEvaluatedSortKey2: stateFixed.lastEvaluatedSortKey2,
    },
  });

  request.url = 'https://' + process.env.REACT_APP_KOM_API_DOMAIN + '/get_history_open';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, stateFixed.action, undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {

    if (response.body.lastEvaluatedKey !== undefined) {
      dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'lastEvaluatedKey', stateFixed.action, pagingIndex], value: response.body.lastEvaluatedKey });
    }
    else {
      dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'lastEvaluatedKey', stateFixed.action, pagingIndex], value: null });
    }

    if (response.body.lastEvaluatedKey2 !== undefined) {
      dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'lastEvaluatedKey2', stateFixed.action, pagingIndex], value: response.body.lastEvaluatedKey2 });
    }
    else {
      dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'lastEvaluatedKey2', stateFixed.action, pagingIndex], value: null });
    }

    dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'pagingIndex', stateFixed.action], value: pagingIndex });

    // // cookie情報更新(アドレス情報)
    // const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
    // const cookiesNew = [
    //       {
    //         action: 'searchPurchaseHistory',
    //         addressType: 'addressMain',
    //         description: `${userName}`,
    //         time: now,
    //         address: stateFixed.addressMain
    //       },
    // ];

    // setAddressesInCookie(state, dispatch, cookies, setCookie, stateFixed.addressMain, cookiesNew);

    return { status: 'fulfilled', body: response.body };
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }
}

export {
  handleClickGetDuelHistoryAll,
}
